/** Default number of ranked candidates visible before pagination. */
export const SMART_ANALYSIS_RESULTS_DEFAULT_LIMIT = 10

/** Increment when the user chooses “show more”. */
export const SMART_ANALYSIS_RESULTS_PAGE_SIZE = 10

/** Featured ranks shown in the employer leaderboard hero section. */
export const SMART_ANALYSIS_LEADERBOARD_FEATURED = 3

export function initialRankedRemainderLimit(featuredCount: number): number {
  return Math.max(0, SMART_ANALYSIS_RESULTS_DEFAULT_LIMIT - featuredCount)
}

export function showMoreBatchSize(visible: number, total: number): number {
  return Math.min(SMART_ANALYSIS_RESULTS_PAGE_SIZE, Math.max(0, total - visible))
}
